<template>
  <div class="wt2-user-assets-actions">
    <wt-dropdown-view
      v-if="!isEmbedded"
      class="-upload-wrapper"
      :openOnHover="true"
      @on-toggle-click="triggerFileOpenDialog()"
      ref="ddvUpload"
    >
      <template slot="label">
        <span class="wticon wticon-upload2" />
      </template>
      <template slot="view">
        <div class="wt2-text-n -option" @click="triggerFileOpenDialog()">
          <i class="wticon wticon-display" />
          {{ 'uploadView.cta.desktop' | culture }}
        </div>

        <div class="-divider" />

        <div class="wt2-text-n -option" @click="triggerFaceOnCamera()">
          <i class="wticon wticon-camera2" />
          {{ 'uploadView.cta.recordVideo' | culture }}
        </div>

        <div class="-divider" />

        <div class="wt2-text-n -option" @click="triggerDropboxDialog()">
          <i class="wticon wticon-dropbox" />
          {{ 'uploadView.cta.dropbox' | culture }}
        </div>

        <div class="-divider" />

        <div class="wt2-text-n -option" @click="triggerOnedriveDialog()">
          <i class="wticon wticon-onedrive" />
          {{ 'uploadView.cta.onedrive' | culture }}
        </div>

        <div class="-divider" />

        <div
          class="wt2-text-n -option"
          @click="triggerGoogleDriveDialog()"
          v-if="isInternal"
        >
          <i class="wticon wticon-google-drive" />
          {{ 'uploadView.cta.googleDrive' | culture }}
        </div>

        <!-- <div class="-divider" /> -->

        <!-- <div class="wt2-text-n -option" @click="openYoutubeUpload()">
                    <i class="wticon wticon-youtube1"/>
                    {{'uploadView.cta.youtube' | culture}}
                </div>

                <div class="-divider"/> -->

        <!-- <div
          class="wt2-text-n -option"
          @click="$emit('open-infographics', 'WEBPAGE', $event)"
        >
          <i class="wticon wticon-globe" />
          {{ 'uploadView.infographic.webpage' | culture }}
        </div> -->
      </template>
    </wt-dropdown-view>

    <div class="-close-panel">
      <wt-button
        class="-close-modal"
        type="primary"
        text="Done"
        title="Close"
        @click="closeModal"
        iconPosition="left"
      />

      <wt-lightbox-dropdown
        :scene="animation.scene"
        :auto-height="true"
        :empty-lightbox-text="emptyLightBoxText"
        @preview-asset="previewAsset"
      />
    </div>
  </div>
</template>

<script>
import app from 'app';
import ThirdPartyUpload from 'v/UploadView/ThirdPartyUpload.vue';
import YoutubeUpload from 'v/UploadView/YoutubeUpload.vue';
import GoogleDriveUpload from 'v/UploadView/GoogleDriveUpload.vue';
import WtFaceOnCamera from 'components/modals/types/wtFaceOnCamera/wtFaceOnCamera.component.vue';
import wtLightboxDropdown from 'components/assets/wtLightboxDropdown.component.vue';

export default {
  props: {
    isUICompact: { type: Boolean, required: false, default: false },
    closeModal: { type: Function, required: false, default: _.noop },
  },

  components: {
    wtLightboxDropdown,
  },

  data: () => ({
    isEmbedded: app.isEmbedded,
    animation: {
      scene: 'mounted',
    },
  }),

  computed: Object.assign(
    {
      isInternal() {
        return serverProfile.environment !== 'prod';
      },
      emptyLightBoxText() {
        return app.culture.lightBox.emptyFooter;
      },
    },
    app.Vuex.mapGetters(['selectedAssets']),
    app.Vuex.mapState({
      addSelectedAsset_timestamp: (state) =>
        state.story.addSelectedAsset_timestamp,
    })
  ),

  watch: {
    addSelectedAsset_timestamp() {
      if (this.$options.animation.isActive) {
        this.animation.scene = 'fludded';
        this.$options.animation.restart();
      } else {
        this.animation.scene = 'added';
        this.$options.animation.start();
      }
    },
  },

  beforeDestroy() {
    this.$options.animation.stop();
  },

  beforeCreate() {
    Object.assign(this.$options, {
      supportedFileExtensions: tk.context._supportedFileExtensions,
      animation: new app.namespace.Util.Timer(() => {
        this.animation.scene = 'mounted';
      }, 2064), // 1168
    });
  },

  methods: {
    previewAsset(asset) {
      app.namespace.Controller.AssetController.previewLightboxAsset(asset);
    },
    triggerFileOpenDialog() {
      this.$refs.ddvUpload.close();
      this.$emit('open-file');
    },

    triggerGoogleDriveDialog() {
      this.$refs.ddvUpload.close();
      app.namespace.Controller.GoogleDrivePicker.openPicker().then((files) => {
        this.mixinShowViewInModal({
          type: 'normal',
          component: GoogleDriveUpload,
          componentPropsData: {
            initFiles: files,
          },
          backdrop: true,
          closeOnClickOut: false,
        }).$on('close', (res) => {
          if (res.uqModels) {
            this.$emit('select-tab', app.PROVIDERS.MY_GALLERY.id);
            _.each(res.uqModels, (model) => {
              app.rootStore.dispatch('ESCORT_UPLOADING_ASSET', {
                uploadDestination: app.uploadDestination.ASSET_GALLERY,
                asset: model.attributes,
              });
            });
          }
        });
      });
    },

    triggerFaceOnCamera() {
      this.mixinShowViewInModal({
        type: 'normal',
        component: WtFaceOnCamera,
        wrapperClass: ['wt-face-on-camera-container'],
        componentPropsData: {
          source: 'Uploads',
          useSpeechRecognition: false,
        },
        backdrop: true,
        closeOnClickOut: false,
        showCloseButton: false,
        closeOnEscape: false,
      }).$on('close', (res) => {
        if (res && res.blob) {
          app.handleFaceOnCameraResponse({
            blob: res.blob,
            caption: res.caption,
            isLightbox: false,
            autoTranscribe: res.autoTranscribe,
          });
          this.$emit('select-tab', app.PROVIDERS.MY_GALLERY.id);
        }
      });
    },

    triggerDropboxDialog() {
      this.$refs.ddvUpload.close();
      window.Dropbox.choose({
        success: (files) => {
          this.mixinShowViewInModal({
            type: 'normal',
            component: ThirdPartyUpload,
            componentPropsData: {
              provider: 'dropbox',
              initFiles: files,
            },
            backdrop: true,
            closeOnClickOut: false,
          }).$on('close', (res) => {
            if (res.uqModels) {
              this.$emit('select-tab', app.PROVIDERS.MY_GALLERY.id);
              _.each(res.uqModels, (model) => {
                app.rootStore.dispatch('ESCORT_UPLOADING_ASSET', {
                  uploadDestination: app.uploadDestination.ASSET_GALLERY,
                  asset: model.attributes,
                });
              });
            }
          });
        },

        linkType: 'direct',

        multiselect: true,

        extensions: tk.context._supportedFileExtensions.map((v) => {
          return '.' + v.toLowerCase();
        }),

        folderselect: false, // or true
      });
    },

    triggerOnedriveDialog() {
      this.$refs.ddvUpload.close();
      const odOptions = {
        clientId: app.getOnedriveClientId(),
        action: 'download',
        multiSelect: true,
        advanced: {
          redirectUri:
            location.protocol +
            '//' +
            location.host +
            '/resources/html/onedriveRedirect.html',
          queryParameters:
            'select=id,name,size,file,folder,photo,@microsoft.graph.downloadUrl',
          /* display folder and files with  permitted extensions only */
          filter:
            'folder, .' +
            tk.context._supportedFileExtensions.join(',.').toLowerCase(),
        },
        success: (res) => {
          if (res.value.length) {
            const files = [];
            _.each(res.value, (v) => {
              const file = {
                id: v['id'],
                link: v['@microsoft.graph.downloadUrl'],
                name: v['name'],
                bytes: v['size'],
              };
              files.push(file);
            });
            this.mixinShowViewInModal({
              type: 'normal',
              component: ThirdPartyUpload,
              componentPropsData: {
                provider: 'onedrive',
                initFiles: files,
              },
              backdrop: true,
              closeOnClickOut: false,
            }).$on('close', (res) => {
              if (res.uqModels) {
                this.$emit('select-tab', app.PROVIDERS.MY_GALLERY.id);
                _.each(res.uqModels, (model) => {
                  app.rootStore.dispatch('ESCORT_UPLOADING_ASSET', {
                    uploadDestination: app.uploadDestination.ASSET_GALLERY,
                    asset: model.attributes,
                  });
                });
              }
            });
          }
        },
        error: (error) => {
          app.dialog.error({
            type: app.dialog.types.ERROR_1,
            title: `${app.culture.onedriveDialog.errorTitle}`,
            showContactCsm: true,
          });
          console.error(error);
        },
      };
      window.OneDrive.open(odOptions);
    },

    openYoutubeUpload() {
      this.$refs.ddvUpload.close();

      this.mixinShowViewInModal({
        type: 'normal',
        component: YoutubeUpload,
        componentPropsData: {},
        backdrop: true,
        closeOnClickOut: false,
      }).$on('close', (res) => {
        if (res.asset) {
          this.$emit('select-tab', app.PROVIDERS.MY_GALLERY.id);
          app.rootStore.dispatch('ESCORT_UPLOADING_ASSET', {
            uploadDestination: app.uploadDestination.ASSET_GALLERY,
            asset: res.asset,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
